var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"boarding-change-notification"},[_c('tl-icon',{staticClass:"boarding-change-notification__icon",attrs:{"icon":"exclamation-circle"}}),_vm._v(" "),_c('div',{staticClass:"boarding-change-notification__text"},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }